import moment from 'moment'

export function makeClassSectionExamData (data) {
  let returnData = {
    session_id: data.session_id,
    class_id: data.class_id,
    exam_id: data.exam_id,
    grades: data.grades,
    exam_setting_id: data.exam_setting_id,
    certificate_template_id: data.certificate_template_id,
    required_fee_ids: data.required_fee_ids || [],
  }
  if (data.attendance_from_date && data.attendance_to_date) {
    returnData.attendance_period = [
      moment(data.attendance_from_date),
      moment(data.attendance_to_date),
    ]
  }

  if (data.is_all_section) {
    returnData.sections = [0]
  } else {
    returnData.sections = [data.section_id]
  }

  return returnData
}
export function makeClassSectionExamSubjectData (subjectData) {
  const subjects = subjectData.map((element, index) => {
    return {
      ['subjects[' + element.subject_id + '][selected]']: true,
      ['subjects[' + element.subject_id + '][sort_order_no]']: element.sort_order_no,
      ['subjects[' + element.subject_id + '][subject_id]']: element.subject_id,
      ['subjects[' + element.subject_id + '][full_mark]']: element.full_mark,
      ['subjects[' + element.subject_id + '][pass_mark]']: element.pass_mark,
      ['subjects[' + element.subject_id + '][theory_full_mark]']: element.theory_full_mark,
      ['subjects[' + element.subject_id + '][theory_pass_mark]']: element.theory_pass_mark,
      ['subjects[' + element.subject_id + '][practical_full_mark]']: element.practical_full_mark,
      ['subjects[' + element.subject_id + '][practical_pass_mark]']: element.practical_pass_mark,
      ['subjects[' + element.subject_id + '][date]']: moment(element.date),
      ['subjects[' + element.subject_id + '][start_time]']: element.start_time ? moment(element.start_time, 'hh:mm:ss') : undefined,
      ['subjects[' + element.subject_id + '][end_time]']: element.end_time ? moment(element.end_time, 'hh:mm:ss') : undefined,
      ['subjects[' + element.subject_id + '][grades_only]']: element.grades_only === 1,
      ['subjects[' + element.subject_id + '][has_practical]']: element.has_practical === 1,
      ['subjects[' + element.subject_id + '][is_oral]']: element.is_oral === 1,
      ['subjects[' + element.subject_id + '][has_exam]']: element.has_exam !== 1,
      ['subjects[' + element.subject_id + '][is_in_total]']: element.is_in_total === 1,
      ['subjects[' + element.subject_id + '][is_composite]']: element.is_composite === 1,
    }
  })

  let returnData = {}

  subjects.forEach(element => {
    returnData = { ...returnData, ...element }
  })

  return returnData
}
